/*
 * @Author: 勇城
 * @Date: 2021-07-08 16:49:24
 * @LastEditTime: 2021-07-30 14:20:45
 * @FilePath: \yimob\src\pages\ask\askIndex\api.js
 */
/**
 * @created on 2017/9/19
 * @author laixinyu <laixinyualex@gmail.com>
 **/

import { getRunTime } from '../../../public-resource/libs/utils/index'

// 判断环境
let HOST = getRunTime('//m.xinli001.com')
let YIAPI_HOST = getRunTime('//yiapi.xinli001.com')
let STATIC = getRunTime('//static.xinli001.com')
let protocol = window.location.protocol
let qaHOST = getRunTime('//qaapi.xinli001.com')
// HOST = '//m-qc1.xinli001.com'
// YIAPI_HOST = '//yiapi-qc1.xinli001.com'
// qaHOST = '//qaapi-qc1.xinli001.com'
let IS_APP = window.$platform.isYixinliApp

module.exports = {
  host: protocol + HOST,
  static: protocol + STATIC,
  isLogin: `${HOST}/ajax/get-user-header`,
  levelPopup: `${HOST}/qa/qa-api/popup-window`, // 等级弹窗
  getWXShareConfig: `${HOST}/wx/get-wx-package.json`,
  getQaData: `${HOST}/qa/get-qa-tag-data-list.json`, // 数据获取
  login: IS_APP
    ? 'yixinli://open_user_login'
    : `${HOST}/account/login?next=${encodeURIComponent(
        protocol + HOST + location.pathname + location.search + location.hash
      )}`,
  sameFeel: `${HOST}/qa/qa-same-feeling-toggle.json`, // 同感接口
  likeQuestion: `${HOST}/qa/like-question-answer.json`, // 点赞接口
  answerReplay: `${HOST}/qa/post-answer-reply.json`, // 回答问题
  storeQuestion: `${HOST}/qa/store-question.json`, // 关注问题
  noticesToggle: `${HOST}/qa/change-qa-notices-toggle.json`, // 关注问题清0
  followAttention: `${HOST}/ajax/user-follow-toggle1.json`, // 关注用户
  getQaFocusNotices: `${HOST}/qa/get-qa-focus-notices.json`, // 关注用户
  getQaReply: `${HOST}/qa/get-answer-reply-list.json`, // 关注用户
  getADList: `${YIAPI_HOST}/v5/yi/get-ad-lists.json`, // 获取广告流
  latestQuestion: `${HOST}/qa/get-latest-question.json`, // 新问题接口
  getUserNotice: `${HOST}/qa/get-user-notice.json`, // 顶部消息通知
  clearInviteNum: `${HOST}/qa/clear-user-invite-num.json`, // 清除被邀请回答数
  getRankList: `${HOST}/qa/answer-ranking-list`, // 实时榜单
  getRewardList: `${HOST}/qa/get-reward-question-list`, // 悬赏专区
  getInviteNum: `${HOST}/qa/get-user-invite-num.json`, // 获取用户剩余问答邀请数
  postQuestion: `${HOST}/qa/post-question-view`, // 向ta提问
  userMessage: `${STATIC}/msite/index.html#/newsList-index`, // 消息列表页
  inviteList: `${HOST}/qa/invitation-list`, // 还能邀答
  getBranchStatus: `${qaHOST}/cantonal/cantonal-master-status`, // 分馆状态
  getBranchList: `${qaHOST}/cantonal/list`, // 分馆列表
  getNewRecents: `${qaHOST}/story/new-recents`,
  getTopicsList: `${qaHOST}/topics`, // 话题集
  getTopicsListBySearchWord: `${qaHOST}/topics/searchTopics`, // 故事集搜索
  getTopicsRecommend: `${qaHOST}/topics/recommend`, // 话题故事 - 推荐话题
  getActivityRecommend: `${qaHOST}/recommend/activity`, // 精选活动
  getWriteRankList: `${qaHOST}/topics/getRankingList`, // 书写榜
  getPsychicCoachList: `${YIAPI_HOST}/v5/yi/get-psychic-coach-list.json`, // 心探教练列表
  getPsychicCoachAd: `${YIAPI_HOST}/v5/yi/get-ad-lists.json` // 心探教练广告位
}



// WEBPACK FOOTER //
// ./src/pages/ask/askIndex/api.js